import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Layout } from "banafo-design-system";
import ApiKeys from "src/features/apiKeys/ApiKeys";
import Title from "./Title";
import Header from "./Header";
const SpeechToTextApiPage = () => {
    return (_jsxs(Layout, { header: _jsx(Header, {}), scrollBar: 1, options: {
            contentProps: { className: "px-200" }
        }, children: [_jsx(Title, {}), _jsx(ApiKeys, {})] }));
};
export default SpeechToTextApiPage;
